import { createStyles, makeStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core';
import { BLACK_COLOR } from '../../../../constants/colors';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      display: 'flex',
    },
    header: {
      backgroundColor: '#87888A',
      padding: 8,
    },
    headerTitle: {
      color: BLACK_COLOR,
      fontSize: 16,
      fontWeight: 'bold',
    },
    headerSubtitle: {
      color: 'white',
      fontSize: 12,
    },
  }),
);

export default useStyles;
